var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFencingAndGates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000099620157808915492830000014386639451423919242_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.82,
    y: 31.5,
    className: "st1",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000154405409920661067280000004206611044502286509_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.82,
    y: 16.5,
    className: "st1",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000006700630602611618200000011392051356866466494_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.82,
    y: 23.5,
    className: "st1",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000150084919077447436520000009988393994669065624_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.82,
    y: 31.5,
    className: "st1",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000029034413600535704870000001993468115000890018_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.82,
    y: 16.5,
    className: "st1",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000115508665969934989950000008149024025970485941_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.82,
    y: 23.5,
    className: "st1",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000151513569257927611160000017024852791816133003_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.82,
    y: 31.5,
    className: "st1",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000147900607966454454130000014310185320051765149_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.82,
    y: 16.5,
    className: "st1",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000134251264943782268730000012464015123852812429_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.82,
    y: 23.5,
    className: "st1",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000158015158275409157110000015082217346220935344_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.82,
    y: 31.5,
    className: "st1",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000182499459146091366130000013902167091910025135_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.82,
    y: 16.5,
    className: "st1",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000083067447785957617800000017406761658996055995_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.82,
    y: 23.5,
    className: "st1",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000101068587935097594010000015977866515739816598_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.82,
    y: 31.5,
    className: "st1",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000119818732305618429930000007149759180111896468_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.82,
    y: 16.5,
    className: "st1",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000069370689842686342950000017816992595075795875_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.82,
    y: 23.5,
    className: "st1",
    width: 3,
    height: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000032613266985748199180000009100063329050652830_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.32,
    y: 11,
    className: "st0",
    width: 5,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.32,43.5h-5c-0.28,0-0.5-0.22-0.5-0.5V11c0-0.28,0.22-0.5,0.5-0.5h5c0.28,0,0.5,0.22,0.5,0.5v32 C47.82,43.28,47.6,43.5,47.32,43.5z M42.82,42.5h4v-31h-4V42.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000158721163962685245690000017359992953249250236_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.69,28.79c-0.02-0.22,0.02-0.46,0.16-0.63c0.14-0.17,0.39-0.27,0.6-0.19c0.25,0.1,0.35,0.39,0.41,0.65 c0.05,0.23,0.09,0.48,0.03,0.7s-0.28,0.43-0.51,0.41C44.91,29.7,44.73,29.17,44.69,28.79z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000132086085366619360940000006900952091043566525_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.79,37.85c-0.02-0.22,0.02-0.46,0.16-0.63c0.14-0.17,0.39-0.27,0.6-0.19c0.25,0.1,0.35,0.39,0.41,0.65 c0.05,0.23,0.09,0.48,0.03,0.7c-0.07,0.23-0.28,0.43-0.51,0.41C45.01,38.76,44.82,38.24,44.79,37.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000118361522633029553380000006822019131222839718_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.64,17.53c-0.02-0.22,0.02-0.46,0.16-0.63c0.14-0.17,0.39-0.27,0.6-0.19c0.25,0.1,0.35,0.39,0.41,0.65 c0.05,0.23,0.09,0.48,0.03,0.7c-0.07,0.23-0.28,0.43-0.51,0.41C44.86,18.44,44.68,17.92,44.64,17.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000119097264733780774960000006936046252686035120_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.32,
    y: 8,
    className: "st0",
    width: 5,
    height: 34
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.32,42.5h-5c-0.28,0-0.5-0.22-0.5-0.5V8c0-0.28,0.22-0.5,0.5-0.5h5c0.28,0,0.5,0.22,0.5,0.5v34 C39.82,42.28,39.6,42.5,39.32,42.5z M34.82,41.5h4v-33h-4V41.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000060715030938519140460000000914523098500345528_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.66,28.79c-0.02-0.22,0.02-0.46,0.16-0.63c0.14-0.17,0.39-0.27,0.6-0.19c0.25,0.1,0.35,0.39,0.41,0.65 c0.05,0.23,0.09,0.48,0.03,0.7s-0.28,0.43-0.51,0.41C36.89,29.7,36.7,29.17,36.66,28.79z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000038372082019980899150000017479404727127136442_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.76,37.85c-0.02-0.22,0.02-0.46,0.16-0.63s0.39-0.27,0.6-0.19c0.25,0.1,0.35,0.39,0.41,0.65 c0.05,0.23,0.09,0.48,0.03,0.7c-0.07,0.23-0.28,0.43-0.51,0.41C36.98,38.76,36.79,38.24,36.76,37.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000097478177615192379000000011644097135318923960_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.61,17.53c-0.02-0.22,0.02-0.46,0.16-0.63c0.14-0.17,0.39-0.27,0.6-0.19c0.25,0.1,0.35,0.39,0.41,0.65 c0.05,0.23,0.09,0.48,0.03,0.7c-0.07,0.23-0.28,0.43-0.51,0.41C36.84,18.44,36.65,17.92,36.61,17.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000093163225251591269390000011679866095929773458_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.32,
    y: 11,
    className: "st0",
    width: 5,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.32,43.5h-5c-0.28,0-0.5-0.22-0.5-0.5V11c0-0.28,0.22-0.5,0.5-0.5h5c0.28,0,0.5,0.22,0.5,0.5v32 C31.82,43.28,31.6,43.5,31.32,43.5z M26.82,42.5h4v-31h-4V42.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000164493142068575230150000006933941185248185531_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.64,28.79c-0.02-0.22,0.02-0.46,0.16-0.63c0.14-0.17,0.39-0.27,0.6-0.19c0.25,0.1,0.35,0.39,0.41,0.65 c0.05,0.23,0.09,0.48,0.03,0.7s-0.28,0.43-0.51,0.41C28.86,29.7,28.67,29.17,28.64,28.79z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000028300013124778545410000009615179043283556532_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.73,37.85c-0.02-0.22,0.02-0.46,0.16-0.63c0.14-0.17,0.39-0.27,0.6-0.19c0.25,0.1,0.35,0.39,0.41,0.65 c0.05,0.23,0.09,0.48,0.03,0.7c-0.07,0.23-0.28,0.43-0.51,0.41C28.95,38.76,28.76,38.24,28.73,37.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000075879257865281686860000016908652308197583288_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.59,17.53c-0.02-0.22,0.02-0.46,0.16-0.63c0.14-0.17,0.39-0.27,0.6-0.19c0.25,0.1,0.35,0.39,0.41,0.65 c0.05,0.23,0.09,0.48,0.03,0.7c-0.07,0.23-0.28,0.43-0.51,0.41C28.81,18.44,28.62,17.92,28.59,17.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000107578871779504430300000012352821405055051451_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.32,
    y: 8,
    className: "st0",
    width: 5,
    height: 34
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.32,42.5h-5c-0.28,0-0.5-0.22-0.5-0.5V8c0-0.28,0.22-0.5,0.5-0.5h5c0.28,0,0.5,0.22,0.5,0.5v34 C23.82,42.28,23.6,42.5,23.32,42.5z M18.82,41.5h4v-33h-4V41.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000165945240384916977200000014580297878428725174_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.61,28.79c-0.02-0.22,0.02-0.46,0.16-0.63c0.14-0.17,0.39-0.27,0.6-0.19c0.25,0.1,0.35,0.39,0.41,0.65 c0.05,0.23,0.09,0.48,0.03,0.7s-0.28,0.43-0.51,0.41C20.83,29.7,20.64,29.17,20.61,28.79z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000171690617815864833800000008627236132302323858_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.7,37.85c-0.02-0.22,0.02-0.46,0.16-0.63c0.14-0.17,0.39-0.27,0.6-0.19c0.25,0.1,0.35,0.39,0.41,0.65 c0.05,0.23,0.09,0.48,0.03,0.7c-0.07,0.23-0.28,0.43-0.51,0.41C20.92,38.76,20.74,38.24,20.7,37.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000108290899377750962700000014764411290492214445_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.56,17.53c-0.02-0.22,0.02-0.46,0.16-0.63c0.14-0.17,0.39-0.27,0.6-0.19c0.25,0.1,0.35,0.39,0.41,0.65 c0.05,0.23,0.09,0.48,0.03,0.7c-0.07,0.23-0.28,0.43-0.51,0.41C20.78,18.44,20.59,17.92,20.56,17.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000080914967270393910240000004062958458403676603_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.32,
    y: 11,
    className: "st0",
    width: 5,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.32,43.5h-5c-0.28,0-0.5-0.22-0.5-0.5V11c0-0.28,0.22-0.5,0.5-0.5h5c0.28,0,0.5,0.22,0.5,0.5v32 C15.82,43.28,15.6,43.5,15.32,43.5z M10.82,42.5h4v-31h-4V42.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000158728355536499128210000004536669665298193290_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.58,28.79c-0.02-0.22,0.02-0.46,0.16-0.63c0.14-0.17,0.39-0.27,0.6-0.19c0.25,0.1,0.35,0.39,0.41,0.65 c0.05,0.23,0.09,0.48,0.03,0.7c-0.07,0.23-0.28,0.43-0.51,0.41C12.8,29.7,12.61,29.17,12.58,28.79z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000114075251679912027440000008561875636281326767_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.67,37.85c-0.02-0.22,0.02-0.46,0.16-0.63c0.14-0.17,0.39-0.27,0.6-0.19c0.25,0.1,0.35,0.39,0.41,0.65 c0.05,0.23,0.09,0.48,0.03,0.7c-0.07,0.23-0.28,0.43-0.51,0.41C12.9,38.76,12.71,38.24,12.67,37.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000001636633433557540960000012831450361820307894_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.53,17.53c-0.02-0.22,0.02-0.46,0.16-0.63c0.14-0.17,0.39-0.27,0.6-0.19c0.25,0.1,0.35,0.39,0.41,0.65 c0.05,0.23,0.09,0.48,0.03,0.7c-0.07,0.23-0.28,0.43-0.51,0.41C12.75,18.44,12.56,17.92,12.53,17.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000119093622575911040910000018246504894196503224_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.32,
    y: 7,
    className: "st0",
    width: 5,
    height: 36
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.32,43.5h-5c-0.28,0-0.5-0.22-0.5-0.5V7c0-0.28,0.22-0.5,0.5-0.5h5c0.28,0,0.5,0.22,0.5,0.5v36 C7.82,43.28,7.6,43.5,7.32,43.5z M2.82,42.5h4v-35h-4V42.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000116928907232145667610000005372297203374095232_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.55,28.79c-0.02-0.22,0.02-0.46,0.16-0.63c0.14-0.17,0.39-0.27,0.6-0.19c0.25,0.1,0.35,0.39,0.41,0.65 c0.05,0.23,0.09,0.48,0.03,0.7c-0.07,0.23-0.28,0.43-0.51,0.41C4.77,29.7,4.59,29.17,4.55,28.79z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000171711496487643140130000006198304489616068270_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.65,37.85c-0.02-0.22,0.02-0.46,0.16-0.63c0.14-0.17,0.39-0.27,0.6-0.19c0.25,0.1,0.35,0.39,0.41,0.65 c0.05,0.23,0.09,0.48,0.03,0.7c-0.07,0.23-0.28,0.43-0.51,0.41C4.87,38.76,4.68,38.24,4.65,37.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000008853292479204712350000011533312923969235613_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.5,17.53c-0.02-0.22,0.02-0.46,0.16-0.63c0.14-0.17,0.39-0.27,0.6-0.19c0.25,0.1,0.35,0.39,0.41,0.65 c0.05,0.23,0.09,0.48,0.03,0.7c-0.07,0.23-0.28,0.43-0.51,0.41C4.72,18.44,4.54,17.92,4.5,17.53z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000055683679098641635210000016177160741441182357_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000059998643298258239900000017621569891316066179_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.11,40.25c0.46,0.64,0.7,2.45,0.69,3.25h5.96c0-0.48,0.01-1.97,0.09-2.45c0.11-0.64,0.29-1.29,0.72-1.77 c-0.47,0.25-0.88,0.69-1.06,1.2c0.28-0.97,0.7-1.92,1.27-2.74c-0.7,0.4-1.27,1-1.73,1.66c-0.46,0.66-0.86,1.35-1.22,2.07 c0.14-0.97,0.43-1.92,0.91-2.77c-0.84,0.53-1.36,1.58-1.32,2.59c-0.18-1.2-0.76-2.32-1.61-3.16c0.62,0.86,0.92,1.92,0.81,2.97 c-0.47-1.56-1.33-3.02-2.42-4.21c0.4,0.69,0.8,1.39,1,2.16c0.23,0.85,0.22,1.78,0.2,2.66c-0.3-0.77-0.64-1.54-1.11-2.21 c-0.47-0.68-1.1-1.22-1.84-1.56c0.86,0.92,1.44,2.07,1.7,3.32C2.94,40.81,2.57,40.45,2.11,40.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000074439775116705225750000013017581676558768021_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.66,40.25c0.46,0.64,0.7,2.45,0.69,3.25h5.96c0-0.48,0.01-1.97,0.09-2.45c0.11-0.64,0.29-1.29,0.72-1.77 c-0.47,0.25-0.88,0.69-1.06,1.2c0.28-0.97,0.7-1.92,1.27-2.74c-0.7,0.4-1.27,1-1.73,1.66s-0.86,1.35-1.22,2.07 c0.14-0.97,0.43-1.92,0.91-2.77c-0.84,0.53-1.36,1.58-1.32,2.59c-0.18-1.2-0.76-2.32-1.61-3.16c0.62,0.86,0.92,1.92,0.81,2.97 c-0.47-1.56-1.33-3.02-2.42-4.21c0.4,0.69,0.8,1.39,1,2.16c0.23,0.85,0.22,1.78,0.2,2.66c-0.3-0.77-0.64-1.54-1.11-2.21 c-0.47-0.68-1.1-1.22-1.84-1.56c0.86,0.92,1.44,2.07,1.7,3.32C1.48,40.81,1.12,40.45,0.66,40.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000070833383425388294840000006949109276574066068_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.16,40.25c0.46,0.64,0.7,2.45,0.69,3.25h5.96c0-0.48,0.01-1.97,0.09-2.45c0.11-0.64,0.29-1.29,0.72-1.77 c-0.47,0.25-0.88,0.69-1.06,1.2c0.28-0.97,0.7-1.92,1.27-2.74c-0.7,0.4-1.27,1-1.73,1.66s-0.86,1.35-1.22,2.07 c0.14-0.97,0.43-1.92,0.91-2.77c-0.84,0.53-1.36,1.58-1.32,2.59c-0.18-1.2-0.76-2.32-1.61-3.16c0.62,0.86,0.92,1.92,0.81,2.97 c-0.47-1.56-1.33-3.02-2.42-4.21c0.4,0.69,0.8,1.39,1,2.16c0.23,0.85,0.22,1.78,0.2,2.66c-0.3-0.77-0.64-1.54-1.11-2.21 c-0.47-0.68-1.1-1.22-1.84-1.56c0.86,0.92,1.44,2.07,1.7,3.32C10.98,40.81,10.61,40.45,10.16,40.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000177477354699061468400000014099818572433850260_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.7,40.25c0.46,0.64,0.7,2.45,0.69,3.25h5.96c0-0.48,0.01-1.97,0.09-2.45c0.11-0.64,0.29-1.29,0.72-1.77 c-0.47,0.25-0.88,0.69-1.06,1.2c0.28-0.97,0.7-1.92,1.27-2.74c-0.7,0.4-1.27,1-1.73,1.66s-0.86,1.35-1.22,2.07 c0.14-0.97,0.43-1.92,0.91-2.77c-0.84,0.53-1.36,1.58-1.32,2.59c-0.18-1.2-0.76-2.32-1.61-3.16c0.62,0.86,0.92,1.92,0.81,2.97 c-0.47-1.56-1.33-3.02-2.42-4.21c0.4,0.69,0.8,1.39,1,2.16c0.23,0.85,0.22,1.78,0.2,2.66c-0.3-0.77-0.64-1.54-1.11-2.21 c-0.47-0.68-1.1-1.22-1.84-1.56c0.86,0.92,1.44,2.07,1.7,3.32C9.53,40.81,9.16,40.45,8.7,40.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000085218180454459244230000004718993804883665047_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.2,40.25c0.46,0.64,0.7,2.45,0.69,3.25h5.96c0-0.48,0.01-1.97,0.09-2.45c0.11-0.64,0.29-1.29,0.72-1.77 c-0.47,0.25-0.88,0.69-1.06,1.2c0.28-0.97,0.7-1.92,1.27-2.74c-0.7,0.4-1.27,1-1.73,1.66s-0.86,1.35-1.22,2.07 c0.14-0.97,0.43-1.92,0.91-2.77c-0.84,0.53-1.36,1.58-1.32,2.59c-0.18-1.2-0.76-2.32-1.61-3.16c0.62,0.86,0.92,1.92,0.81,2.97 c-0.47-1.56-1.33-3.02-2.42-4.21c0.4,0.69,0.8,1.39,1,2.16c0.23,0.85,0.22,1.78,0.2,2.66c-0.3-0.77-0.64-1.54-1.11-2.21 c-0.47-0.68-1.1-1.22-1.84-1.56c0.86,0.92,1.44,2.07,1.7,3.32C19.02,40.81,18.66,40.45,18.2,40.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000164487221653214317640000012019207424707429307_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.75,40.25c0.46,0.64,0.7,2.45,0.69,3.25h5.96c0-0.48,0.01-1.97,0.09-2.45c0.11-0.64,0.29-1.29,0.72-1.77 c-0.47,0.25-0.88,0.69-1.06,1.2c0.28-0.97,0.7-1.92,1.27-2.74c-0.7,0.4-1.27,1-1.73,1.66s-0.86,1.35-1.22,2.07 c0.14-0.97,0.43-1.92,0.91-2.77c-0.84,0.53-1.36,1.58-1.32,2.59c-0.18-1.2-0.76-2.32-1.61-3.16c0.62,0.86,0.92,1.92,0.81,2.97 c-0.47-1.56-1.33-3.02-2.42-4.21c0.4,0.69,0.8,1.39,1,2.16c0.23,0.85,0.22,1.78,0.2,2.66c-0.3-0.77-0.64-1.54-1.11-2.21 c-0.47-0.68-1.1-1.22-1.84-1.56c0.86,0.92,1.44,2.07,1.7,3.32C17.57,40.81,17.2,40.45,16.75,40.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000073713474488703611030000006043296917546411168_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.24,40.25c0.46,0.64,0.7,2.45,0.69,3.25h5.96c0-0.48,0.01-1.97,0.09-2.45c0.11-0.64,0.29-1.29,0.72-1.77 c-0.47,0.25-0.88,0.69-1.06,1.2c0.28-0.97,0.7-1.92,1.27-2.74c-0.7,0.4-1.27,1-1.73,1.66s-0.86,1.35-1.22,2.07 c0.14-0.97,0.43-1.92,0.91-2.77c-0.84,0.53-1.36,1.58-1.32,2.59c-0.18-1.2-0.76-2.32-1.61-3.16c0.62,0.86,0.92,1.92,0.81,2.97 c-0.47-1.56-1.33-3.02-2.42-4.21c0.4,0.69,0.8,1.39,1,2.16c0.23,0.85,0.22,1.78,0.2,2.66c-0.3-0.77-0.64-1.54-1.11-2.21 c-0.47-0.68-1.1-1.22-1.84-1.56c0.86,0.92,1.44,2.07,1.7,3.32C27.06,40.81,26.7,40.45,26.24,40.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000067935973291359530300000012191479398968238258_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.79,40.25c0.46,0.64,0.7,2.45,0.69,3.25h5.96c0-0.48,0.01-1.97,0.09-2.45c0.11-0.64,0.29-1.29,0.72-1.77 c-0.47,0.25-0.88,0.69-1.06,1.2c0.28-0.97,0.7-1.92,1.27-2.74c-0.7,0.4-1.27,1-1.73,1.66s-0.86,1.35-1.22,2.07 c0.14-0.97,0.43-1.92,0.91-2.77c-0.84,0.53-1.36,1.58-1.32,2.59c-0.18-1.2-0.76-2.32-1.61-3.16c0.62,0.86,0.92,1.92,0.81,2.97 c-0.47-1.56-1.33-3.02-2.42-4.21c0.4,0.69,0.8,1.39,1,2.16c0.23,0.85,0.22,1.78,0.2,2.66c-0.3-0.77-0.64-1.54-1.11-2.21 c-0.47-0.68-1.1-1.22-1.84-1.56c0.86,0.92,1.44,2.07,1.7,3.32C25.61,40.81,25.25,40.45,24.79,40.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000044148130893199628320000012718347482405041820_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.28,40.25c0.46,0.64,0.7,2.45,0.69,3.25h5.96c0-0.48,0.01-1.97,0.09-2.45c0.11-0.64,0.29-1.29,0.72-1.77 c-0.47,0.25-0.88,0.69-1.06,1.2c0.28-0.97,0.7-1.92,1.27-2.74c-0.7,0.4-1.27,1-1.73,1.66c-0.46,0.66-0.86,1.35-1.22,2.07 c0.14-0.97,0.43-1.92,0.91-2.77c-0.84,0.53-1.36,1.58-1.32,2.59c-0.18-1.2-0.76-2.32-1.61-3.16c0.62,0.86,0.92,1.92,0.81,2.97 c-0.47-1.56-1.33-3.02-2.42-4.21c0.4,0.69,0.8,1.39,1,2.16c0.23,0.85,0.22,1.78,0.2,2.66c-0.3-0.77-0.64-1.54-1.11-2.21 c-0.47-0.68-1.1-1.22-1.84-1.56c0.86,0.92,1.44,2.07,1.7,3.32C35.1,40.81,34.74,40.45,34.28,40.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000106831509943277216970000015454535716231893684_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.83,40.25c0.46,0.64,0.7,2.45,0.69,3.25h5.96c0-0.48,0.01-1.97,0.09-2.45c0.11-0.64,0.29-1.29,0.72-1.77 c-0.47,0.25-0.88,0.69-1.06,1.2c0.28-0.97,0.7-1.92,1.27-2.74c-0.7,0.4-1.27,1-1.73,1.66s-0.86,1.35-1.22,2.07 c0.14-0.97,0.43-1.92,0.91-2.77c-0.84,0.53-1.36,1.58-1.32,2.59c-0.18-1.2-0.76-2.32-1.61-3.16c0.62,0.86,0.92,1.92,0.81,2.97 c-0.47-1.56-1.33-3.02-2.42-4.21c0.4,0.69,0.8,1.39,1,2.16c0.23,0.85,0.22,1.78,0.2,2.66c-0.3-0.77-0.64-1.54-1.11-2.21 c-0.47-0.68-1.1-1.22-1.84-1.56c0.86,0.92,1.44,2.07,1.7,3.32C33.65,40.81,33.29,40.45,32.83,40.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000155119866610000715610000015933889659300544402_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.32,40.25c0.46,0.64,0.7,2.45,0.69,3.25h5.96c0-0.48,0.01-1.97,0.09-2.45c0.11-0.64,0.29-1.29,0.72-1.77 c-0.47,0.25-0.88,0.69-1.06,1.2c0.28-0.97,0.7-1.92,1.27-2.74c-0.7,0.4-1.27,1-1.73,1.66s-0.86,1.35-1.22,2.07 c0.14-0.97,0.43-1.92,0.91-2.77c-0.84,0.53-1.36,1.58-1.32,2.59c-0.18-1.2-0.76-2.32-1.61-3.16c0.62,0.86,0.92,1.92,0.81,2.97 c-0.47-1.56-1.33-3.02-2.42-4.21c0.4,0.69,0.8,1.39,1,2.16c0.23,0.85,0.22,1.78,0.2,2.66c-0.3-0.77-0.64-1.54-1.11-2.21 c-0.47-0.68-1.1-1.22-1.84-1.56c0.86,0.92,1.44,2.07,1.7,3.32C43.15,40.81,42.78,40.45,42.32,40.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000163758968631793048010000013734179942680987570_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.87,40.25c0.46,0.64,0.7,2.45,0.69,3.25h5.96c0-0.48,0.01-1.97,0.09-2.45c0.11-0.64,0.29-1.29,0.72-1.77 c-0.47,0.25-0.88,0.69-1.06,1.2c0.28-0.97,0.7-1.92,1.27-2.74c-0.7,0.4-1.27,1-1.73,1.66s-0.86,1.35-1.22,2.07 c0.14-0.97,0.43-1.92,0.91-2.77c-0.84,0.53-1.36,1.58-1.32,2.59c-0.18-1.2-0.76-2.32-1.61-3.16c0.62,0.86,0.92,1.92,0.81,2.97 c-0.47-1.56-1.33-3.02-2.42-4.21c0.4,0.69,0.8,1.39,1,2.16c0.23,0.85,0.22,1.78,0.2,2.66c-0.3-0.77-0.64-1.54-1.11-2.21 c-0.47-0.68-1.1-1.22-1.84-1.56c0.86,0.92,1.44,2.07,1.7,3.32C41.69,40.81,41.33,40.45,40.87,40.25z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFencingAndGates);
export default __webpack_public_path__ + "static/media/fencing-and-gates.8c2e8655b48b8c33e50c8bb54bb14bec.svg";
export { ForwardRef as ReactComponent };